import React from "react";
import { Col, Row } from "react-bootstrap";

export default function MarketingBranding() {
    return (
        <>
            <div className="aboutus_bg">
                <div className="aboutus-img-content">
                    <h1>Social Media & Digital Advertising-Amplify Your Brand’s Voice</h1>
                </div>
            </div>
            <div className="container my-5">
                <div className="row">
                    {/* Main Content Section */}
                    <div className="col-lg-8 vendor-main-content">
                        <img
                            src="images/market.jpg"
                            alt="Emergency Fund Management"
                            className="img-fluid"
                        />
                        <p>Build a strong online presence with expertly managed social media and targeted digital advertising campaigns.</p>
                        <h2 style={{fontWeight:'bold'}}>Services Include</h2>
                        <p>
                            <ul>
                                <li><b>Strategic social media management (Facebook, Instagram, LinkedIn, Twitter)</b> <br /><br/></li>
                                <li><b>Audience growth and community building</b> <br /><br/></li>
                                <li><b>Paid ad campaigns on Google, Facebook, Instagram</b> <br /><br/></li>
                                <li><b>Content creation: graphics, videos, storytelling</b> <br/><br/></li>
                                <li><b>Performance analytics and reporting</b></li>
                            </ul>
                        </p>
                        
                    </div>

                    {/* Sidebar Section */}
                    <div className="col-lg-4 vendor-sidebar">
                        {/* Why Choose Us */}
                        <div className="vendor-section vendor-services">
                            <h3 style={{fontWeight:'bold'}}>Benefits</h3>
                            <ul>
                                <li><span class="arrow">➤</span>Increased brand visibility</li>
                                <li><span class="arrow">➤</span>Targeted traffic and qualified leads</li>
                                <li><span class="arrow">➤</span>Loyal customer engagement</li>
                                <li><span class="arrow">➤</span>Higher conversion rates</li>
                            </ul>
                        </div>

                        {/* Latest Posts */}
                        <div className="vendor-section vendor-latest-posts" style={{ marginBottom: '20px' }}>
                            <img
                                src="images/brand.jpg"
                                alt="Emergency Fund Management"
                                className="img-fluid"
                            />
                            
                        </div>
                        {/* Contact Info */}
                        {/* <div className="vendor-section vendor-contact-info">
                            <h3 style={{fontWeight:'bold'}}>Contact Info</h3>
                            <p>
                                <span> <i class="fa-solid fa-location-dot fa-xl" style={{ color: '#b80404' }}></i> </span>&nbsp;&nbsp;
                                <span>934 McCowan Road, Toronto M1P 3H6</span></p>
                            <p><i class="fa-solid fa-headset fa-xl" style={{ color: '#b80404' }}></i>&nbsp;&nbsp;+1 (647) 716-1330</p>

                            <p> <i class="fa-solid fa-envelope fa-xl" style={{ color: '#b80404' }}></i>&nbsp;&nbsp;info@rojancanada.com</p>

                        </div> */}
                    </div>
                </div>
            </div >
        </>
    );
}
